exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-uploads-transition .card[data-v-1b50b5dc]{transition:transform .15s}.file-limit-reached[data-v-1b50b5dc]{padding:0 5px;color:#ccc}.caption-uploader[data-v-1b50b5dc]{padding:10px 10px 15px}", ""]);

// exports
